<template>
  <div class="hero-block">
    <div class="text-wrap">
      <span>First up next week is...</span>
      <h2>{{ upnext }}</h2>
    </div>
    <img class="co-host griffin" :src="griffin" />
    <img class="co-host rachel" :src="rachel" />
  </div>
</template>
<script>
export default {
  name: "HeroBlock",

  data() {
    return {};
  },
  computed: {
    griffin() {
      if (this.upnext == "Griffin") {
        return require("@/assets/griffin-g.png");
      } else {
        return require("@/assets/griffin-r.png");
      }
    },
    rachel() {
      if (this.upnext == "Rachel") {
        return require("@/assets/rachel-r.png");
      } else {
        return require("@/assets/rachel-g.png");
      }
    }
  },
  props: {
    upnext: {
      type: String,
      default: "…"
    }
  }
};
</script>
<style lang="scss" scoped>
$break-small: 765px;

.hero-block {
  height: 60vh;
  // min-height: 75vw;
  position: relative;

  @media screen and (max-width: $break-small) {
    height: 50vh;
    min-height: 400px;
  }

  .text-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media screen and (max-width: $break-small) {
      top: 33%;
    }

    h2 {
      color: #12a3ff;
      font-size: 10em;
      letter-spacing: -0.2vw;
      line-height: 1;
      margin: 0;
      text-transform: uppercase;
      @media screen and (max-width: $break-small) {
        font-size: 22vw;
      }
    }

    span {
      font-family: "Quattrocento", serif;
      font-size: 2em;
      color: #f56b6b;
      @media screen and (max-width: $break-small) {
        font-size: 7vw;
      }
    }
  }
}

.co-host {
  position: absolute;
  bottom: 0;
  width: 20%;

  @media screen and (max-width: $break-small) {
    width: 150px;
  }
}

.rachel {
  right: 0;
}

.griffin {
  left: 0;
}
</style>
